import {BaseCachedService} from './Core/BaseCachedService';

class SpeciesNativityService extends BaseCachedService {
    get Url() { return super.Url + "/speciesNativities"; }
    get ModelName() { return "SpeciesNativity"; }
    get PrimaryKeyProperty() { return "speciesNativityId"; }
}

export const service = new SpeciesNativityService();

